import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { f as u } from "./index-LyFokDcn.mjs";
import { m as h } from "./tss-DN0acMKN.mjs";
import { H as j } from "./headline-DF2GOgMa.mjs";
import { I as w } from "./icon-tile-BJ1ib0c2.mjs";
import { F as y } from "./flex-Cc3osQLf.mjs";
const H = h()((r) => {
  const { constructs: i, spacing: o, typography: n } = r;
  return {
    description: {
      color: i.text.neutral.strong,
      fontSize: n.small.fontSize,
      lineHeight: n.small.lineHeight
    },
    dividersTop: {
      backgroundColor: i.border.neutral.xWeak,
      border: "none",
      height: "1px",
      margin: `${o(4)} 0 ${o(2.5)} 0`,
      width: "100%"
    },
    dividersBottom: {
      backgroundColor: i.border.neutral.xWeak,
      border: "none",
      height: "1px",
      margin: `${o(2)} 0 ${o(2.5)} 0`,
      width: "100%"
    },
    iconContainer: {
      fill: i.text.primary.strong,
      marginRight: o(2),
      alignSelf: "flex-start"
    },
    content: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    actions: {
      marginLeft: "auto"
    }
  };
}), z = (r) => ({
  small: "extra-small",
  medium: "small",
  large: "medium"
})[r] ?? "small", g = (r) => {
  const { actions: i, biId: o, description: n = "", divider: a = !1, icon: l, id: d, size: c = "medium", title: s, titleComponent: m } = r, { classes: t } = H(r);
  return /* @__PURE__ */ e.jsx("div", { "data-bi-id": o, id: d, children: u.ifFeature(
    "encore",
    /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      a !== "bottom" && a && /* @__PURE__ */ e.jsx("hr", { className: t.dividersTop }),
      /* @__PURE__ */ e.jsxs("div", { className: t.content, children: [
        l && /* @__PURE__ */ e.jsx("div", { className: t.iconContainer, children: typeof l == "string" && /* @__PURE__ */ e.jsx(w, { height: "100%", icon: l, size: 40 }) }),
        /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx(j, { component: m, size: z(c), children: s }),
          n && /* @__PURE__ */ e.jsx("div", { className: t.description, children: n })
        ] }),
        i && /* @__PURE__ */ e.jsx("div", { className: t.actions, children: i })
      ] }),
      a === "bottom" && /* @__PURE__ */ e.jsx("hr", { className: t.dividersBottom })
    ] }),
    "Section.Header component is only available with Encore enabled."
  ) });
}, k = ({ ariaLabel: r, children: i, gap: o = 0, title: n, ...a }) => /* @__PURE__ */ e.jsx("section", { ...a, children: u.ifFeature(
  "encore",
  /* @__PURE__ */ e.jsxs(y, { flexDirection: "column", gap: o, children: [
    n && /* @__PURE__ */ e.jsx(g, { divider: "top", size: "medium", title: n }),
    i
  ] }),
  "Subsection component is only available with Encore enabled."
) }), F = h()((r, i) => {
  const { borderRadiuses: o, constructs: n, mixins: a, palette: l, spacing: d } = r, { flex: c, gap: s, height: m, minHeight: t, paddingTop: x, title: p, overflow: f, overflowX: S, overflowY: v } = i;
  return {
    root: {
      backgroundColor: l.common.white,
      borderRadius: o[400],
      boxShadow: a.boxShadow("500", n.surface.neutral.xxStrong),
      boxSizing: "border-box",
      display: "flex",
      flex: c,
      flexDirection: "column",
      gap: s !== void 0 ? d(s) : void 0,
      height: m || "auto",
      minHeight: t || "auto",
      padding: d(4),
      paddingTop: p ? d(2.5) : x,
      overflow: f,
      overflowX: S,
      overflowY: v,
      "@media print": {
        background: "none",
        borderRadius: 0,
        boxShadow: "none",
        paddingInline: 0
      }
    }
  };
}), b = ({
  ariaLabel: r,
  ariaLabelledBy: i,
  children: o,
  flex: n,
  gap: a = 0,
  height: l,
  minHeight: d,
  paddingTop: c = "32px",
  title: s,
  overflow: m,
  overflowX: t,
  overflowY: x
}) => {
  const { classes: p } = F({ flex: n, gap: a, height: l, minHeight: d, paddingTop: c, title: s, overflow: m, overflowX: t, overflowY: x });
  return u.ifFeature(
    "encore",
    /* @__PURE__ */ e.jsxs("section", { "aria-label": r, "aria-labelledby": i, className: p.root, "data-fabric-component": "Section", children: [
      s && /* @__PURE__ */ e.jsx(g, { size: "large", title: s }),
      o
    ] }),
    null
  );
};
b.Header = g;
b.Subsection = k;
export {
  b as S,
  k as a
};
//# sourceMappingURL=section-CLXJkN7r.mjs.map
